// 本地存储key值前缀
let prefix = '';

/**
 * 设置本地存储前缀
 * @param key
 */
const setPrefix = (key: string) => {
  prefix = key;
};

/**
 * 设置本地缓存
 * @param name 缓存名称
 * @param value 缓存值
 */
const setLocalStore = (name: string, value: any) => {
  if (typeof value === 'object') {
    value = JSON.stringify(value);
  }
  window.localStorage.setItem(`${prefix}${name}`, value);
};

/**
 * 获取本地缓存
 * @param name
 * @returns
 */
const getLocalStore = (name: string) => {
  const value = window.localStorage.getItem(`${prefix}${name}`);
  try {
    if (value == null) {
      return null;
    }
    return JSON.parse(value);
  } catch {
    if (value === 'true') {
      return true;
    } else if (value === 'false') {
      return false;
    }
    return value;
  }
};

/**
 * 清空本地缓存(只删除带设置好prefix的缓存)
 * @param name
 * @returns
 */
const clearLocalStore = () => {
  const keys = Object.keys(localStorage);
  if (Array.isArray(keys)) {
    keys.forEach((key) => {
      if (key.startsWith(prefix)) {
        localStorage.removeItem(key);
      }
    });
  }
};

export { setLocalStore, getLocalStore, setPrefix, clearLocalStore };
